export const TYPES = {
  // authen
  ACTION_LOGIN_SUCCESS: "ACTION_LOGIN_SUCCESS",
  ACTION_LOGIN_FAIL: "ACTION_LOGIN_FAIL",
  ACTION_CALL_API_FAIL: "ACTION_CALL_API_FAIL",

  ACTION_GET_USER_SUCCESS: "ACTION_GET_USER_SUCCESS",
  ACTION_GET_USER_FAIL: "ACTION_GET_USER_FAIL",

  ACTION_GET_EXERCISE_ACTION_CONFIG_SUCCESS: "ACTION_GET_EXERCISE_ACTION_CONFIG_SUCCESS",
  ACTION_GET_EXERCISE_ACTION_CONFIG_FAIL: "ACTION_GET_EXERCISE_ACTION_CONFIG_FAIL",

  ACTION_GET_MY_EXERCISES_SUCCESS: "ACTION_GET_MY_EXERCISES_SUCCESS",
  ACTION_GET_MY_EXERCISES_FAIL: "ACTION_GET_MY_EXERCISES_FAIL",

  ACTION_GET_MY_DIARIES_SUCCESS: "ACTION_GET_MY_DIARIES_SUCCESS",
  ACTION_GET_MY_DIARIES_FAIL: "ACTION_GET_MY_DIARIES_FAIL",

  ACTION_GET_BODY_RECORD_HOUR_SUCCESS: "ACTION_GET_BODY_RECORD_HOUR_SUCCESS",
  ACTION_GET_BODY_RECORD_HOUR_FAIL: "ACTION_GET_BODY_RECORD_HOUR_FAIL",

  ACTION_GET_BODY_RECORD_DAY_WEEK_SUCCESS: "ACTION_GET_BODY_RECORD_DAY_WEEK_SUCCESS",
  ACTION_GET_BODY_RECORD_DAY_WEEK_FAIL: "ACTION_GET_BODY_RECORD_DAY_WEEK_FAIL",

  ACTION_GET_BODY_RECORD_DAY_SUCCESS: "ACTION_GET_BODY_RECORD_DAY_SUCCESS",
  ACTION_GET_BODY_RECORD_DAY_FAIL: "ACTION_GET_BODY_RECORD_DAY_FAIL",

  ACTION_GET_BODY_RECORD_MONTH_SUCCESS: "ACTION_GET_BODY_RECORD_MONTH_SUCCESS",
  ACTION_GET_BODY_RECORD_MONTH_FAIL: "ACTION_GET_BODY_RECORD_MONTH_FAIL",

  ACTION_SET_FLAG_SUCCESS: "ACTION_SET_FLAG_SUCCESS",

  // socket
  ACTION_SEND_MESSAGE: "ACTION_SEND_MESSAGE",
  ACTION_ADD_MESSAGE: "ACTION_ADD_MESSAGE",
  ACTION_CLEAR_ALL_MESSAGES: "ACTION_CLEAR_ALL_MESSAGES",

  // listing
  ACTION_GET_LISTINGS_SUCCESS: "ACTION_GET_LISTINGS_SUCCESS",
  ACTION_GET_LISTINGS_FAIL: "ACTION_GET_LISTINGS_FAIL",

  ACTION_ADD_ALL_LISTING_TO_NEW_COLLECTION_SUCCESS: "ACTION_ADD_ALL_LISTING_TO_NEW_COLLECTION_SUCCESS",
  ACTION_ADD_ALL_LISTING_TO_NEW_COLLECTION_FAIL: "ACTION_ADD_ALL_LISTING_TO_NEW_COLLECTION_FAIL",

  ACTION_GET_LISTING_BY_IDS_SUCCESS: "ACTION_GET_LISTING_BY_IDS_SUCCESS",
  ACTION_GET_LISTING_BY_IDS_FAIL: "ACTION_GET_LISTING_BY_IDS_FAIL",

  ACTION_POST_LISTINGS_SUCCESS: "ACTION_POST_LISTINGS_SUCCESS",
  ACTION_POST_LISTINGS_FAIL: "ACTION_POST_LISTINGS_FAIL",

  ACTION_UPDATE_LISTINGS_HEYDATA_SUCCESS: "ACTION_UPDATE_LISTINGS_HEYDATA_SUCCESS",
  ACTION_UPDATE_LISTINGS_HEYDATA_FAIL: "ACTION_UPDATE_LISTINGS_HEYDATA_FAIL",

  ACTION_GET_LISTINGS_30_DAYS_SOLD_SUCCESS: "ACTION_GET_LISTINGS_30_DAYS_SOLD_SUCCESS",
  ACTION_GET_LISTINGS_30_DAYS_SOLD_FAIL: "ACTION_GET_LISTINGS_30_DAYS_SOLD_FAIL",

  // shop
  ACTION_GET_SHOPS_SUCCESS: "ACTION_GET_SHOPS_SUCCESS",
  ACTION_GET_SHOPS_FAIL: "ACTION_GET_SHOPS_FAIL",

  // shop sold chart
  ACTION_GET_SHOP_SOLD_STAT_SUCCESS: "ACTION_GET_SHOP_SOLD_STAT_SUCCESS",
  ACTION_GET_SHOP_SOLD_STAT_FAIL: "ACTION_GET_SHOP_SOLD_STAT_FAIL",

  ACTION_GET_SHOP_SOLD_STAT_GROUP_SUCCESS: "ACTION_GET_SHOP_SOLD_STAT_GROUP_SUCCESS",
  ACTION_GET_SHOP_SOLD_STAT_GROUP_FAIL: "ACTION_GET_SHOP_SOLD_STAT_GROUP_FAIL",

  ACTION_GET_SHOP_SOLD_SUCCESS: "ACTION_GET_SHOP_SOLD_SUCCESS",
  ACTION_GET_SHOP_SOLD_FAIL: "ACTION_GET_SHOP_SOLD_FAIL",

  ACTION_GET_LATEST_SHOP_SOLD_SUCCESS: "ACTION_GET_LATEST_SHOP_SOLD_SUCCESS",
  ACTION_GET_LATEST_SHOP_SOLD_FAIL: "ACTION_GET_LATEST_SHOP_SOLD_FAIL",

  // task
  ACTION_GET_ALL_TASKS_SUCCESS: "ACTION_GET_ALL_TASKS_SUCCESS",
  ACTION_GET_ALL_TASKS_FAIL: "ACTION_GET_ALL_TASKS_FAIL",

  ACTION_GET_ALL_BOT_TASKS_SUCCESS: "ACTION_GET_ALL_BOT_TASKS_SUCCESS",
  ACTION_GET_ALL_BOT_TASKS_FAIL: "ACTION_GET_ALL_BOT_TASKS_FAIL",

  ACTION_UPDATE_TASK_SUCCESS: "ACTION_UPDATE_TASK_SUCCESS",
  ACTION_UPDATE_TASK_FAIL: "ACTION_UPDATE_TASK_FAIL",

  ACTION_DELETE_TASK_SUCCESS: "ACTION_DELETE_TASK_SUCCESS",
  ACTION_DELETE_TASK_FAIL: "ACTION_DELETE_TASK_FAIL",

  ACTION_GET_LOGS_SUCCESS: "ACTION_GET_LOGS_SUCCESS",
  ACTION_GET_LOGS_FAIL: "ACTION_GET_LOGS_FAIL",

  // collection
  ACTION_GET_ALL_COLLECTIONS_SUCCESS: "ACTION_GET_ALL_COLLECTIONS_SUCCESS",
  ACTION_GET_ALL_COLLECTIONS_FAIL: "ACTION_GET_ALL_COLLECTIONS_FAIL",

  ACTION_ADD_NEW_COLLECTION_SUCCESS: "ACTION_ADD_NEW_COLLECTION_SUCCESS",
  ACTION_ADD_NEW_COLLECTION_FAIL: "ACTION_ADD_NEW_COLLECTION_FAIL",

  ACTION_TOGGLE_AIMESSAGE_IN_COLLECTION_SUCCESS: "ACTION_TOGGLE_AIMESSAGE_IN_COLLECTION_SUCCESS",
  ACTION_TOGGLE_AIMESSAGE_IN_COLLECTION_FAIL: "ACTION_TOGGLE_AIMESSAGE_IN_COLLECTION_FAIL",

  ACTION_REMOVE_LISTING_FROM_COLLECTION_SUCCESS: "ACTION_REMOVE_LISTING_FROM_COLLECTION_SUCCESS",
  ACTION_REMOVE_LISTING_FROM_COLLECTION_FAIL: "ACTION_REMOVE_LISTING_FROM_COLLECTION_FAIL",

  ACTION_UPDATE_COLLECTION_SUCCESS: "ACTION_UPDATE_COLLECTION_SUCCESS",
  ACTION_UPDATE_COLLECTION_FAIL: "ACTION_UPDATE_COLLECTION_FAIL",

  // bot
  ACTION_GET_ALL_BOTS_SUCCESS: "ACTION_GET_ALL_BOTS_SUCCESS",
  ACTION_GET_ALL_BOTS_FAIL: "ACTION_GET_ALL_BOTS_FAIL",

  ACTION_GET_LOCAL_DATA_SUCCESS: "ACTION_GET_LOCAL_DATA_SUCCESS",
  ACTION_GET_LOCAL_DATA_FAIL: "ACTION_GET_LOCAL_DATA_FAIL",

  // autop2p
  ACTION_GET_ALL_AUTOP2P_PAYMENTS_SUCCESS: "ACTION_GET_ALL_AUTOP2P_PAYMENTS_SUCCESS",
  ACTION_GET_ALL_AUTOP2P_PAYMENTS_FAIL: "ACTION_GET_ALL_AUTOP2P_PAYMENTS_FAIL",

  ACTION_UPDATE_AUTOP2P_PAYMENT_SUCCESS: "ACTION_UPDATE_AUTOP2P_PAYMENT_SUCCESS",
  ACTION_UPDATE_AUTOP2P_PAYMENT_FAIL: "ACTION_UPDATE_AUTOP2P_PAYMENT_FAIL",

  // ai conversation
  ACTION_GET_ALL_AI_CONVERSATIONS_SUCCESS: "ACTION_GET_ALL_AI_CONVERSATIONS_SUCCESS",
  ACTION_GET_ALL_AI_CONVERSATIONS_FAIL: "ACTION_GET_ALL_AI_CONVERSATIONS_FAIL",

  ACTION_UPDATE_AI_CONVERSATION_SUCCESS: "ACTION_UPDATE_AI_CONVERSATION_SUCCESS",
  ACTION_UPDATE_AI_CONVERSATION_FAIL: "ACTION_UPDATE_AI_CONVERSATION_FAIL",

  // ai message
  ACTION_GET_ALL_AI_MESSAGES_SUCCESS: "ACTION_GET_ALL_AI_MESSAGES_SUCCESS",
  ACTION_GET_ALL_AI_MESSAGES_FAIL: "ACTION_GET_ALL_AI_MESSAGES_FAIL",

  ACTION_UPDATE_ALL_AI_MESSAGES_SUCCESS: "ACTION_UPDATE_ALL_AI_MESSAGES_SUCCESS",
  ACTION_UPDATE_ALL_AI_MESSAGES_FAIL: "ACTION_UPDATE_ALL_AI_MESSAGES_FAIL",

  ACTION_DELETE_AI_MESSAGE_SUCCESS: "ACTION_DELETE_AI_MESSAGE_SUCCESS",
  ACTION_DELETE_AI_MESSAGE_FAIL: "ACTION_DELETE_AI_MESSAGE_FAIL",

  // Project Types
  ACTION_GET_PROJECTS_SUCCESS: "ACTION_GET_PROJECTS_SUCCESS",
  ACTION_GET_PROJECTS_FAIL: "ACTION_GET_PROJECTS_FAIL",
  ACTION_GET_PROJECT_SUCCESS: "ACTION_GET_PROJECT_SUCCESS",
  ACTION_GET_PROJECT_FAIL: "ACTION_GET_PROJECT_FAIL",
  ACTION_CREATE_PROJECT_SUCCESS: "ACTION_CREATE_PROJECT_SUCCESS",
  ACTION_CREATE_PROJECT_FAIL: "ACTION_CREATE_PROJECT_FAIL",
  ACTION_UPDATE_PROJECT_SUCCESS: "ACTION_UPDATE_PROJECT_SUCCESS",
  ACTION_UPDATE_PROJECT_FAIL: "ACTION_UPDATE_PROJECT_FAIL",
  ACTION_DELETE_PROJECT_SUCCESS: "ACTION_DELETE_PROJECT_SUCCESS",
  ACTION_DELETE_PROJECT_FAIL: "ACTION_DELETE_PROJECT_FAIL",

  // Commit Types
  ACTION_GET_COMMITS_SUCCESS: "ACTION_GET_COMMITS_SUCCESS",
  ACTION_GET_COMMITS_FAIL: "ACTION_GET_COMMITS_FAIL",
  ACTION_GET_COMMIT_SUCCESS: "ACTION_GET_COMMIT_SUCCESS",
  ACTION_GET_COMMIT_FAIL: "ACTION_GET_COMMIT_FAIL",

  // K3Doc Actions
  ACTION_GET_K3DOCS_SUCCESS: "ACTION_GET_K3DOCS_SUCCESS",
  ACTION_GET_K3DOCS_FAIL: "ACTION_GET_K3DOCS_FAIL",
  ACTION_GET_K3DOC_SUCCESS: "ACTION_GET_K3DOC_SUCCESS",
  ACTION_GET_K3DOC_FAIL: "ACTION_GET_K3DOC_FAIL",
  ACTION_SET_K3DOCS_SUCCESS: "ACTION_SET_K3DOCS_SUCCESS",
  ACTION_SET_K3DOCS_FAIL: "ACTION_SET_K3DOCS_FAIL",

  // K3Script Actions
  ACTION_GET_K3SCRIPTS_SUCCESS: "ACTION_GET_K3SCRIPTS_SUCCESS",
  ACTION_GET_K3SCRIPTS_FAIL: "ACTION_GET_K3SCRIPTS_FAIL",
  ACTION_GET_K3SCRIPT_SUCCESS: "ACTION_GET_K3SCRIPT_SUCCESS",
  ACTION_GET_K3SCRIPT_FAIL: "ACTION_GET_K3SCRIPT_FAIL",
  ACTION_SET_K3SCRIPTS_SUCCESS: "ACTION_SET_K3SCRIPTS_SUCCESS",
  ACTION_SET_K3SCRIPTS_FAIL: "ACTION_SET_K3SCRIPTS_FAIL",

  // K3Agent Actions
  ACTION_GET_K3AGENTS_SUCCESS: "ACTION_GET_K3AGENTS_SUCCESS",
  ACTION_GET_K3AGENTS_FAIL: "ACTION_GET_K3AGENTS_FAIL",
  ACTION_GET_K3AGENT_TASKS_SUCCESS: "ACTION_GET_K3AGENT_TASKS_SUCCESS",
  ACTION_GET_K3AGENT_TASKS_FAIL: "ACTION_GET_K3AGENT_TASKS_FAIL",
  ACTION_GET_K3AGENT_LOGS_SUCCESS: "ACTION_GET_K3AGENT_LOGS_SUCCESS",
  ACTION_GET_K3AGENT_LOGS_FAIL: "ACTION_GET_K3AGENT_LOGS_FAIL",
  ACTION_ASSIGN_K3AGENT_JOB_SUCCESS: "ACTION_ASSIGN_K3AGENT_JOB_SUCCESS",
  ACTION_ASSIGN_K3AGENT_JOB_FAIL: "ACTION_ASSIGN_K3AGENT_JOB_FAIL",
  ACTION_DELETE_K3AGENT_TASK_SUCCESS: "ACTION_DELETE_K3AGENT_TASK_SUCCESS",
  ACTION_DELETE_K3AGENT_TASK_FAIL: "ACTION_DELETE_K3AGENT_TASK_FAIL",
  ACTION_UPDATE_K3AGENT_TASK_SUCCESS: "ACTION_UPDATE_K3AGENT_TASK_SUCCESS",
  ACTION_UPDATE_K3AGENT_TASK_FAIL: "ACTION_UPDATE_K3AGENT_TASK_FAIL",
  ACTION_GET_K3AGENT_SUCCESS: "ACTION_GET_K3AGENT_SUCCESS",
  ACTION_GET_K3AGENT_FAIL: "ACTION_GET_K3AGENT_FAIL",
  ACTION_SET_K3AGENTS_SUCCESS: "ACTION_SET_K3AGENTS_SUCCESS",
  ACTION_SET_K3AGENTS_FAIL: "ACTION_SET_K3AGENTS_FAIL",

  // K3Task Actions
  ACTION_GET_K3TASKS_SUCCESS: "ACTION_GET_K3TASKS_SUCCESS",
  ACTION_GET_K3TASKS_FAIL: "ACTION_GET_K3TASKS_FAIL",
  ACTION_GET_K3TASK_SUCCESS: "ACTION_GET_K3TASK_SUCCESS",
  ACTION_GET_K3TASK_FAIL: "ACTION_GET_K3TASK_FAIL",
  ACTION_SET_K3TASKS_SUCCESS: "ACTION_SET_K3TASKS_SUCCESS",
  ACTION_SET_K3TASKS_FAIL: "ACTION_SET_K3TASKS_FAIL",
  ACTION_GET_K3TASK_LOGS_SUCCESS: "ACTION_GET_K3TASK_LOGS_SUCCESS",
  ACTION_GET_K3TASK_LOGS_FAIL: "ACTION_GET_K3TASK_LOGS_FAIL",

  // Permission
  ACTION_GET_PERMISSIONS_LOADING: "ACTION_GET_PERMISSIONS_LOADING",
  ACTION_GET_PERMISSIONS_SUCCESS: "ACTION_GET_PERMISSIONS_SUCCESS",
  ACTION_GET_PERMISSIONS_FAIL: "ACTION_GET_PERMISSIONS_FAIL",

  // User Group
  ACTION_SET_USER_GROUPS_LOADING: "ACTION_SET_USER_GROUPS_LOADING",
  ACTION_SET_USER_GROUPS_SUCCESS: "ACTION_SET_USER_GROUPS_SUCCESS",
  ACTION_SET_USER_GROUPS_FAIL: "ACTION_SET_USER_GROUPS_FAIL",

  ACTION_CREATE_USER_GROUP_LOADING: "ACTION_CREATE_USER_GROUP_LOADING",
  ACTION_CREATE_USER_GROUP_SUCCESS: "ACTION_CREATE_USER_GROUP_SUCCESS",
  ACTION_CREATE_USER_GROUP_FAIL: "ACTION_CREATE_USER_GROUP_FAIL",

  ACTION_GET_USER_GROUPS_LOADING: "ACTION_GET_USER_GROUPS_LOADING",
  ACTION_GET_USER_GROUPS_SUCCESS: "ACTION_GET_USER_GROUPS_SUCCESS",
  ACTION_GET_USER_GROUPS_FAIL: "ACTION_GET_USER_GROUPS_FAIL",

  ACTION_GET_USERS_LOADING: "ACTION_GET_USERS_LOADING",
  ACTION_GET_USERS_SUCCESS: "ACTION_GET_USERS_SUCCESS",
  ACTION_GET_USERS_FAIL: "ACTION_GET_USERS_FAIL",

  ACTION_SET_USERS_LOADING: "ACTION_SET_USERS_LOADING",
  ACTION_SET_USERS_SUCCESS: "ACTION_SET_USERS_SUCCESS",
  ACTION_SET_USERS_FAIL: "ACTION_SET_USERS_FAIL",

  // K3Flow Actions
  ACTION_GET_K3FLOWS_SUCCESS: "ACTION_GET_K3FLOWS_SUCCESS",
  ACTION_GET_K3FLOWS_FAIL: "ACTION_GET_K3FLOWS_FAIL",
  ACTION_GET_K3FLOW_SUCCESS: "ACTION_GET_K3FLOW_SUCCESS",
  ACTION_GET_K3FLOW_FAIL: "ACTION_GET_K3FLOW_FAIL",
  ACTION_SET_K3FLOWS_SUCCESS: "ACTION_SET_K3FLOWS_SUCCESS",
  ACTION_SET_K3FLOWS_FAIL: "ACTION_SET_K3FLOWS_FAIL",
}
